export default function isPickOptionValid(option) {
    return option.title !== '' && option.weight > 0;
}
